<template>
  <div>
    <a-row type="flex" justify="end">
      <a-col>
        <a-button
          type="primary"
          @click="editRole()"
          v-if="isGranted('system_setting.ip_white_manager.btn_global_create')"
        >
          <a-icon type="plus"></a-icon>新建白名单
        </a-button>
      </a-col>
    </a-row>

    <a-row :gutter="80" align="top" style="padding-top:20px;">
      <a-col>
        <a-table
          :pagination="pagination"
          :dataSource="tableData"
          :columns="columns"
          rowKey="id"
          :loading="loading"
          @change="getData"
        >
          <template slot="action" slot-scope="text, record">
            <a-row type="flex" :gutter="10" justify="start">
              <a-col>
                <a
                  @click.prevent="editRole(record)"
                  v-if="isGranted('system_setting.ip_white_manager.btn_list_edit')"
                  >编辑</a
                >
              </a-col>
              <a-col>
                <a
                  @click.prevent="delRole(record)"
                  v-if="
                    isGranted('system_setting.ip_white_manager.btn_list_delete')
                  "
                  >删除</a
                >
              </a-col>
            </a-row>
          </template>
        </a-table>
      </a-col>
    </a-row>
    <operate-role-modal ref="operateModal" @ok="getData()"></operate-role-modal>
  </div>
</template>

<script>
import OperateRoleModal from "./operate-role-modal";
import Api from "@/api";
import { mapGetters } from "vuex";
import baseComponentVue from "@/components/base-component.vue";
export default {
  name: "Role",
  extends: baseComponentVue,
  data() {
    return {
      loading: false,
      tableData: [],
      columns: [],
      pagination: {
        pageSize: 10,
        current: 1,
        total: 0,
        pageSizeOptions: ["10", "20", "50"],
        showTotal: total => `共 ${total} 条`,
        showQuickJumper: true,
        showSizeChanger: true
      },
    };
  },
  components: { OperateRoleModal },
  computed: {
    ...mapGetters(["isGranted", "isAnyGranted"])
  },
  created() {
    this.setColumns();
    this.getData();
  },
  methods: {
    setColumns() {
      let columns = [
        { title: "ID", dataIndex: "id" },
        { title: "IP", dataIndex: "ip" },
        { title: "描述", dataIndex: "description" }
      ];
      if (
        this.isAnyGranted([
          "system_setting.ip_white_manager.btn_list_edit",
          "system_setting.ip_white_manager.btn_list_delete"
        ])
      ) {
        columns.push({
          title: "操作",
          key: "action",
          scopedSlots: { customRender: "action" }
        });
      }
      this.columns = columns;
    },
    async getData(pagination) {
      this.loading = true;
      if (pagination) {
        let pager = { ...this.pagination };
        pager.current = pagination.current;
        pager.pageSize = pagination.pageSize;
        this.pagination = pager;
      } else {
        // this.pagination.current = 1;
      }
      let params = {
        page: this.pagination.current,
        limit: this.pagination.pageSize
      };
      let {list} = await Api.system.whiteList(params);
      this.tableData = list.list;
      this.pagination.total = + list.total
      this.loading = false;
    },
    async checkStatus(record) {
      try {
        await Api.system.changeRoleStatus({
          id: record.id,
          status: record.status == "1" ? "2" : "1"
        });
        record.status = record.status == "1" ? "2" : "1";
      } catch (e) {}
    },
    editRole(record) {
      let { operateModal } = this.$refs;
      operateModal.show(record);
    },
    delRole(record) {
      const h = this.$createElement;
      this.$confirm({
        title: "温馨提示",
        content: h("div", { style: { paddingTop: "20px" } }, [
          h("p", "确定要删除该数据"),
        ]),
        onOk: () => {
          return new Promise(async (resolve, reject) => {
            try {
              await Api.system.whiteDelete({ id: record.id });
              this.getData();
            } catch (e) {}
            resolve();
          });
        }
      });
    }
  }
};
</script>

<style scoped lang="scss"></style>
